export const T = {
  en_GB: { perMonth: "/month", perQuarter: "/quarter", perYear: "/year" },
  nb_NO: { perMonth: "/mnd", perQuarter: "/kvartal", perYear: "/år" },
} as const;
